import axios from "axios";
import URL_CONST from "@/kuaa/kuaa-url-const";
import Swal from "sweetalert2";
import XLSX from "xlsx";
import moment from "moment";

const kuaaParser = {
  /**
   * 신규교우 일괄처리용 text data parser
   * 제공받은 text data 를 api 가 요구하는 형식에 맞게 parsing 해 줍니다.
   * @param textFile input[type=file] 의 e.target.files[0] 객체입니다.
   * @param callback parsing 이 끝난 데이터를 담아 보낼 콜백입니다.
   */
  parseTextNewMemberData(textFile, callback) {
    // 아래의 key 순서는 대학측에서 제공하는 text 파일 의 데이터 순서를 그대로 다른 것입니다.
    const KEYS = [
      "memberNo", //교우번호
      "memberHnm", //교우명
      "memberCnm", //한자명
      "memberEnm", //영문명
      "registerNo", //주민등록번호
      "sex", //성별
      "bornCd", //본적(사용안함)
      "homeZipcd", //자택우편
      "homeAddress1", //자택주소
      "homeTel", //자택전화
      "degreeCd", //학력(사용안하는듯) << 10
      "hakbun", //학번
      "enterYm", //입학년월
      "graduationYm", //졸업년월
      "collegeCd", //대학코드
      "collegeNm", //대학명
      "classCd", //학과코드 (현재의 대학코드는 이 학과 구 코드로 찾아야 함)
      "classNm", //학과명
      "classMajor", //전공 (여기서 사용안함) << 18
      "unuseKey7", //부전공 (여기서 사용안함) << 19
      "classMinor", //복수전공 (여기서 사용안함) << 20
      "unuseKey9", //사용안함 (불명, 확인 필요) << 21
      "classSmajor", //사용안함 (불명, 확인 필요) << 22
      "unuseKey11", //사용안함 (불명, 확인 필요) << 23
      "graduationNo", //졸업회수
      "companyId", //기업체코드
      "officeZipcd", //직장우편번호
      "officeAddress1", //직장주소
      "partNm", //직장부서
      "levelNm", // 직장직위 << 30
      "officeDirect", //직장전화
      "officeFax", //직장 팩스
      "cellular", //휴대폰
      "eMail" //이메일 << 34"
    ];

    let reader = new FileReader();
    reader.readAsText(textFile, "EUC-KR");

    reader.onload = readerEvent => {
      let content = readerEvent.target.result;
      let memberListRaw = content.split("\n");
      let list = [];

      memberListRaw.forEach((dataString, index) => {
        if(String(dataString).trim().length > 1){
          let temp = encodeURI(dataString).split("%1C");
          let d = {
            id: index + 1
          };

          // 제공받은 text data 형식 중 사용하지 않는 key는 생성하지 않음
          const unuseKeys = [19, 21, 23];
          KEYS.forEach((key, idx) => {
            if(unuseKeys.indexOf(idx) === -1)
              d[key] = decodeURI(temp[idx]);
          });
          list.push(d);
        }
      });
      callback(list);
    };
  },

  parseExcelNewMemberData(xlsFile, callback) {
    let reader = new FileReader();
    let result = [];
    let returnArr = [];
    reader.onload = (e) => {
      let data = reader.result;
      // let data = e.target.result;
      let workbook = XLSX.read(data, {type: 'binary'});

      workbook.SheetNames.forEach(sheetName => {
        const roa = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName]);
        //const roa = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName],{header: 1, defval: '', blankrows: true});
        result.push(roa);
      });
      callback(result[0]);
    };
    reader.readAsBinaryString(xlsFile);
  },

  /**
   * 회비 일괄 처리 엑셀파싱
   */
  parseXlsMemberData(xlsFile, callback) {
    let reader = new FileReader();
    let result = [];
    reader.onload = (e) => {
      let data = reader.result;
      // let data = e.target.result;
      let workbook = XLSX.read(data, {type: 'binary'});
      workbook.Strings.forEach(str => {
        // const roa = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName]);
        if(str.t && str.t!=''){
          result.push(str.t);
        }
      });
      callback(result);
    };
    reader.readAsBinaryString(xlsFile);
  },
  /**
   * 이벤트 교우저장 일괄 처리 엑셀파싱
   */
  parseXlsEventMemberData(xlsFile, callback) {
    let reader = new FileReader();
    let result = [];
    reader.onload = (e) => {
      let data = reader.result;
      // let data = e.target.result;
      let workbook = XLSX.read(data, {type: 'binary'});

      workbook.SheetNames.forEach(sheetName => {
        const roa = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName]);
        result.push(roa);
      });
      callback(result[0]);
    };
    reader.readAsBinaryString(xlsFile);
  },

  /**
   * 우편물 반송 처리 엑셀파싱
   */
  parseXlsBackPostData(xlsFile, callback) {
    let reader = new FileReader();
    let result = [];
    let returnArr = [];
    reader.onload = (e) => {
      let data = reader.result;
      // let data = e.target.result;
      let workbook = XLSX.read(data, {type: 'binary'});
      workbook.Strings.forEach(str => {
        // const roa = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName]);
        if(str.t && str.t!=''){
          result.push(str.t);
        }
      });

      // 파싱된 데이터 형식에 맞게 가공
      // 교우번호 8자리+'1 or 2' + 6자리날짜값(년도2자리+월2자리+일2자리)
      result.forEach((item)=>{
        returnArr.push({
          memberNo : item.substring(0,8),
          postFlag : '0'+item.substring(8,9),
          loadDate : '20'+item.substring(9)
        });
      })

      callback(returnArr);
    };
    reader.readAsBinaryString(xlsFile);
  },

  /**
   * OCR 처리 엑셀파싱
   */
  parseXlsFeeOCRData(xlsFile, callback) {
    let reader = new FileReader();
    let result = [];
    let returnArr = [];
    reader.onload = (e) => {
      let data = reader.result;
      // let data = e.target.result;
      let workbook = XLSX.read(data, {type: 'binary'});
      workbook.SheetNames.forEach(sheetName => {
        const roa = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName],{header: 1, defval: '', blankrows: true});
        result.push(roa);
      });
      result[0].forEach((arr)=>{
    	  
        if(arr[2] && arr[2]!='' && arr[2].length == 20){
          returnArr.push({
            feeGb : '01',
            feeWay : '04',
            feeTime : moment().format("hhmmss"),
            memberNo : arr[2].substring(4, 5) === '2' ? 'KK'+arr[2].substring(7,13): 'K'+arr[2].substring(6,13),
            feeCd : arr[2].substring(13,15),
            feeYear : arr[2].substring(15,19),
            feeAmt : arr[3],
            feeDate : arr[1],
            feeId : arr[2],
            feeTypeNm : '01',
            feeRecvdate : arr[6]
          });
        }
      });

      callback(returnArr);
    };
    reader.readAsBinaryString(xlsFile);
  },

  /**
   * 교우 일괄 처리 엑셀파싱
   */
  parseXlsMemberBundleData(xlsFile, callback) {
    let reader = new FileReader();
    let result = [];
    reader.onload = (e) => {
      let data = reader.result;
      // let data = e.target.result;
      let workbook = XLSX.read(data, {type: 'binary'});
      workbook.SheetNames.forEach(sheetName => {
        const roa = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName],{header: 1, defval: '', blankrows: true});
        result.push(roa);
      });
      callback(result[0]);
    };
    reader.readAsBinaryString(xlsFile);
  },

  /**
   * 회장단 > 위원 일괄 처리 엑셀파싱
   */
  parseXlsScholarshipExecutiveBundleData(xlsFile, callback) {
    let reader = new FileReader();
    let result = [];
    let returnArr = [];
    reader.onload = (e) => {
      let data = reader.result;
      // let data = e.target.result;
      let workbook = XLSX.read(data, {type: 'binary'});

      workbook.SheetNames.forEach(sheetName => {
        const roa = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName]);
        result.push(roa);
      });

      result[0].forEach((obj)=>{
        returnArr.push({
          presidencyCd : obj['presidency_cd'],
          presiLevelCd : obj['presi_level_cd'],
          memberNo : obj['member_no']
        });
      });

      callback(returnArr);
    };
    reader.readAsBinaryString(xlsFile);
  },

  /**
   * 회장단 > 장학금 일괄 처리 엑셀파싱
   */
  parseXlsScholarshipScholarBundleData(xlsFile, callback) {
    let reader = new FileReader();
    let result = [];
    let returnArr = [];
    reader.onload = (e) => {
      let data = reader.result;
      // let data = e.target.result;
      let workbook = XLSX.read(data, {type: 'binary'});
      workbook.SheetNames.forEach(sheetName => {
        const roa = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName]);
        result.push(roa);
      });

      result[0].forEach((obj)=>{
        returnArr.push({
          presidencyCd : obj['presidency_cd'],
          semester : obj['semester'],
          amt : obj['amt'],
          qty : obj['qty']
        });
      });

      callback(returnArr);
    };
    reader.readAsBinaryString(xlsFile);
  },

  /**
   * 장학관리 > 등록금 금액관리 일괄 처리 엑셀파싱
   */
  parseXlsTuitionBundleData(xlsFile, callback) {
    let reader = new FileReader();
    let result = [];
    let returnArr = [];
    reader.onload = (e) => {
      let data = reader.result;
      // let data = e.target.result;
      let workbook = XLSX.read(data, {type: 'binary'});
      workbook.SheetNames.forEach(sheetName => {
        const roa = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName]);
        result.push(roa);
      });

      result[0].forEach((obj)=>{
        returnArr.push({
          semesterCd : obj['SEMESTER_CD'],
          collegeLCd : obj['COLLEGE_L_CD'],
          collegeMCd : obj['COLLEGE_M_CD'],
          collegeSCd : obj['COLLEGE_S_CD'],
          collegeSemesterCd : obj['COLLEGE_SEMESTER_CD'],
          tuitionAmount : obj['TUITION_AMOUNT']
        });
      });

      callback(returnArr);
    };
    reader.readAsBinaryString(xlsFile);
  },

  /**
   * 장학관리 > 교우회(장학) 관리 일괄 처리 엑셀파싱
   */
  parseXlsHomeReBundleData(xlsFile, callback) {
    let reader = new FileReader();
    let result = [];
    let returnArr = [];
    reader.onload = (e) => {
      let data = reader.result;
      // let data = e.target.result;
      let workbook = XLSX.read(data, {type: 'binary'});
      workbook.SheetNames.forEach(sheetName => {
        const roa = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName]);
        result.push(roa);
      });

      result[0].forEach((obj)=>{
        returnArr.push({
          semesterCd : obj['SEMESTER_CD'],
          hakbun : obj['HAKBUN'],
          nm : obj['NM'],
          collegeLCd : obj['COLLEGE_L_CD'],
          collegeMCd : obj['COLLEGE_M_CD'],
          collegeSCd : obj['COLLEGE_S_CD'],
          collegeSemesterCd : obj['COLLEGE_SEMESTER_CD'],
          amountScha : obj['AMOUNT_SCHA'],
          amountUnivTuition : obj['AMOUNT_UNIV_TUITION'],
          amountUnivLiving : obj['AMOUNT_UNIV_LIVING'],
          amountUnivTotal : obj['AMOUNT_UNIV_TOTAL'],
          phone1 : obj['PHONE1'],
          phone2 : obj['PHONE2'],
          eMail : obj['E_MAIL'],
          etc : obj['ETC'],
          incomeQuintile : obj['INCOME_QUINTILE'],
          complateHakjum : obj['COMPLATE_HAKJUM'],
          avgHakjum : obj['AVG_HAKJUM']
        });
      });

      callback(returnArr);
    };
    reader.readAsBinaryString(xlsFile);
  },

  /**
   * 장학신청자 엑셀파싱
   */
  parseXlsApplyRequestData(xlsFile, callback) {
    let reader = new FileReader();
    let result = [];
    let returnArr = [];
    reader.onload = (e) => {
      let data = reader.result;
      // let data = e.target.result;
      let workbook = XLSX.read(data, {type: 'binary'});
      workbook.SheetNames.forEach(sheetName => {
        const roa = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName]);
        result.push(roa);
      });

      result[0].forEach((obj)=>{
        if(!obj['SEMESTER_CD']) return;
        returnArr.push({
          semesterCd: obj['SEMESTER_CD'],
          applyGb: obj['APPLY_GB'],
          hakbun: obj['HAKBUN'],
          nm: obj['NM'],
          sex: obj['SEX'],
          bornYm: obj['BORN_YM'],
          collegeLCd: obj['COLLEGE_L_CD'],
          collegeMCd: obj['COLLEGE_M_CD'],
          collegeSCd: obj['COLLEGE_S_CD'],
          collegeSemesterCd: obj['COLLEGE_SEMESTER_CD'],
          phoneNo1: obj['PHONE_NO1'],
          phoneNo2: obj['PHONE_NO2'],
          email: obj['E_MAIL'],
          completeSemester: obj['COMPLETE_SEMESTER'],
          completeHakjum: obj['COMPLETE_HAKJUM'],
          avgHakjum: obj['AVG_HAKJUM'],
          prev2AvgHakjum: obj['PREV2_AVG_HAKJUM'],
          prev2ComplateHakjum: obj['PREV2_COMPLATE_HAKJUM'],
          prevAvgHakjum: obj['PREV_AVG_HAKJUM'],
          prevComplateHakjum: obj['PREV_COMPLATE_HAKJUM'],
          applyEtc: obj['APPLY_ETC']
        });
      });

      callback(returnArr);
    };
    reader.readAsBinaryString(xlsFile);
  }
};
export default kuaaParser;
